import { Routes, Route } from 'react-router-dom';
import { AudienceProvider } from './contexts/AudienceContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { usePageViews } from './hooks/usePageViews';
import { HomePage } from './pages/HomePage';
import { ServiceDetailPage } from './pages/ServiceDetailPage';
import { ContactPage } from './pages/ContactPage';
import { AudiencePage } from './pages/AudiencePage';
import { PortfolioIndexPage } from './pages/PortfolioIndexPage';
import { ProjectShowcasePage } from './portfolio/ProjectShowcasePage';
import { NotFoundPage } from './pages/NotFoundPage';

function App() {
  usePageViews();

  return (
    <LanguageProvider>
      <AudienceProvider>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services/:slug" element={<ServiceDetailPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/audience/:type" element={<AudiencePage />} />
          <Route path="/portfolio" element={<PortfolioIndexPage />} />
          <Route path="/portfolio/:slug" element={<ProjectShowcasePage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </AudienceProvider>
    </LanguageProvider>
  );
}

export default App;
